import { render, staticRenderFns } from "./ArticleAuthor.vue?vue&type=template&id=be3d8e02&"
import script from "./ArticleAuthor.vue?vue&type=script&lang=js&"
export * from "./ArticleAuthor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports